import React from 'react';

interface State { hasError: boolean; error?: Error; }

export class ErrorBoundary extends React.Component<React.PropsWithChildren<{}>, State> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }
  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('ErrorBoundary caught:', error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 20, color: '#b91c1c' }}>
          <h2>Что-то пошло не так</h2>
          <p>Произошла ошибка на странице. Попробуй обновить (Ctrl+F5) или вернуться назад.</p>
          {this.state.error && <details><summary>Технические детали</summary><pre>{String(this.state.error?.message || this.state.error)}</pre></details>}
        </div>
      );
    }
    return this.props.children;
  }
}
